<template>
  <div class="activities-enroll create-fabu">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="enroll-view">
      <el-form-item label="文章名称" prop="title">
        <div class="form-item">
          <div class="right-ipt">
            <el-input
              v-model="ruleForm.title"
              placeholder="请输入文章名称"
              show-word-limit
              :maxlength="30"
            >
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="文章正文" prop="">
        <div class="form-item">
          <div class="right-ipt">
            富文本
          </div>
        </div>
      </el-form-item>
      <el-form-item label="文章封面" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-button class="fengm-btn" type="danger" @click="showUploadImg">选择图片</el-button>
            <div class="upload-images">
              <div class="upload-item">
                <img class="img-show" :src="require('@/assets/images/upload_demo.jpg')" alt="">
                <i class="el-icon-close icon-close" title="删除"></i>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="专栏类型" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-radio-group v-model="ruleForm.colType">
              <el-radio :label="0">主题专栏</el-radio>
              <el-radio :label="1">大V专栏</el-radio>
            </el-radio-group>
            <div class="sync-dav">
              <el-select
                style="width: 100%"
                v-model="ruleForm.selVal"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in selOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-checkbox v-model="ruleForm.syncDV">同步至大V专栏</el-checkbox>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品来源" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-radio-group v-model="ruleForm.orgin">
              <el-radio :label="0">原创作品</el-radio>
              <el-radio :label="1">转载分享</el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="公开权限" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-radio-group v-model="ruleForm.root">
              <el-radio :label="0">所有人可见</el-radio>
              <el-radio :label="1">仅本人可见</el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="@的人" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-input
              v-model="ruleForm.aite"
              placeholder="输入想要@人的昵称，以“，”隔开，例：李雷，韩梅梅"
            >
            </el-input>
          </div>
        </div>
      </el-form-item>
      <div class="last-btn">
        <el-button size="medium" type="primary"><i class="el-icon-finished"></i> 保存</el-button>
        <el-button size="medium" type="warning"><i class="el-icon-view"></i> 预览</el-button>
        <el-button size="medium" type="success"><i class="el-icon-s-promotion"></i> 发布专栏</el-button>
      </div>
    </el-form>
    <!-- 上传封面弹窗 -->
    <el-dialog
      title="上传图片"
      :visible.sync="dialogUploadImg"
      top="100px"
      :closeOnClickModal="false"
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      :modal-append-to-body="false"
    >
      <div class="cut-img">
        <div class="cropper-wrap-f">
          <div class="cropper-wrap">
            <vue-cropper
              ref="cropper"
              :img="imgOption.img"
              :fixed="imgOption.fixed"
              :autoCrop="imgOption.autoCrop"
              :autoCropWidth="imgOption.autoCropWidth"
              :autoCropHeight="imgOption.autoCropHeight"
              :outputType="imgOption.outputType"
              :fixed-number="imgOption.fixedNumber"
              mode="cover"
            >
            </vue-cropper>
          </div>
        </div>
        <div class="btns">
          <label class="btn">
            <input
              type="file"
              id="uploads"
              style="position:absolute; clip:rect(0 0 0 0);"
              accept="image/png, image/jpeg, image/gif, image/jpg"
              @change="uploadImgNew($event)"
            />
            {{ imgOption.img === "" ? "选择" : "重新选择" }}图片
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer cut-image">
        <el-button type="info" @click="dialogUploadImg = false"><i class="el-icon-refresh-left"></i> 返回</el-button>
        <el-button type="primary" @click="cutOver"><i class="el-icon-finished"></i> 确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {VueCropper} from 'vue-cropper'

export default {
  props: {},
  components: {
    VueCropper
  },
  data () {
    return {
      dialogUploadImg: false,
      imgOption: {
        img: '',
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [11, 7], // 截图框比例
        autoCrop: true, // 是否显示截图框
        autoCropWidth: 500, // 截图框默认宽度
        autoCropHeight: 318, // 截图框默认高度
        outputType: 'png' // 图片输出格式
      },
      selOptions: [
        {
          label: '故事',
          value: 0
        },
        {
          label: '哈哈',
          value: 1
        },
        {
          label: '发的',
          value: 2
        }
      ],
      ruleForm: {
        title: '',
        colType: 0,
        selVal: 0,
        syncDV: false,
        orgin: 0,
        root: 0,
        aite: ''
      },
      rules: {
        title: [{required: true, message: '请输入文章名称', trigger: 'blur'}]
      }
    }
  },
  computed: {},
  mounted () {},
  methods: {
    //显示上传图片弹窗
    showUploadImg () {
      this.dialogUploadImg = true
    },
    uploadImgNew (e) {
      //上传图片
      var file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return false
      }
      var reader = new FileReader()
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }

        this.imgOption.img = data
      }
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    cutOver () {
      // 输出bolb格式地址
      this.$refs.cropper.getCropBlob((data) => {
        var img = window.URL.createObjectURL(data)
        console.log(img);
      })
      // 输出base64格式
      this.$refs.cropper.getCropData((data) => {
        console.log(data);
      })
    },
  }
}
</script>

<style scoped lang="less">
@import "../create.less";
</style>
